import { render, staticRenderFns } from "./BtnGuardar.vue?vue&type=template&id=27547696&"
import script from "./BtnGuardar.vue?vue&type=script&lang=js&"
export * from "./BtnGuardar.vue?vue&type=script&lang=js&"
import style0 from "./BtnGuardar.vue?vue&type=style&index=0&id=27547696&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports